module.exports = __webpack_public_path__ + "static/brand1-984f47d6727691dfb67dd72ebe5abe22.png";